<template>
    <div class="population-view">
        <PopulationList
            :patient-list="patientList"
            :list-title="listTitle"
            :url="url"></PopulationList>
        <div class="detail">
            <router-view
                v-bind:url="url"
                v-bind:print="null">
                </router-view>
            </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'

import PopulationList from '@/module/population/list/List'

export default {
    name: 'reachout-population',

    props: {
        topic: {
            type: String,
            required: true
        }
    },

    watch: {
        topic: {
            immediate: true,
            handler(val) {
                this.loadPatientTickets()
            }
        }
    },

    mounted() {
        this.loadPatients()
    },

    methods: {
        ...mapActions('provider', [
            'loadPatients',
            'loadPatientTickets'
        ]),
    },


    computed: {
        ...mapState('provider', {
            tickets: state => state.tickets,
            ticketsConfig: state => state.ticketsConfig
        }),
        ...mapGetters('provider', [
            'getCurrentProvider'
        ]),
        url() {
            return '/reachout/' + this.topic
        },
        listTitle() {
            const topic = this.ticketsConfig.find((config) => config.id === this.topic)
            if(topic)
                return topic.title
            return ''
        },
        patientList() {
            const topic = this.ticketsConfig.find((config) => config.id === this.topic)                
            if(topic) {
                if(this.getCurrentProvider) {
                    const authPatients = this.tickets
                        .find(({ id }) => id === this.getCurrentProvider).tickets
                        .filter((ticket) => ticket.category_id === topic.category_id && ticket.status !== 'closed')
                        .map((ticket) => ticket.auth)
                    return [...new Set(authPatients)]
                }
                else {
                    const authPatients = this.tickets.flatMap(({ tickets }) => tickets)
                        .filter((ticket) => ticket.category_id === topic.category_id && ticket.status !== 'closed')
                        .map((ticket) => ticket.auth)
                    return [...new Set(authPatients)]
                }
                    
                
            }
            return []
        }
    },

    components: {
        PopulationList
    }
}
</script>

<style>
.list {
	width: 240px;
	height: 100%;
	overflow-y: auto;
	float: left;
	border-right: solid 1px #dfdfdf;
}
.detail {
	height: 100%;
	overflow-y: auto;
}
.filter-view {
    padding: 10px;
    background: #fafafa;

    .el-card {
        margin-bottom: 10px;
    }
}
</style>